/**
 * See list of weblabs in ARMS BFF here:
 * https://tiny.amazon.com/sf2ltd0/codeamazpackAdveblobmainsrc
 */
export enum Weblab {
  ADAM_NE_REGISTRATION_CAPTCHA = 'ADAM_NE_REGISTRATION_CAPTCHA_1033373',
  SINGLE_ACCOUNT_REGISTRATION = 'SINGLE_ACCOUNT_REGISTRATION_UI_952407',
  PLD_REGISTRATION = 'PLD_REGISTRATION_UI_1019875',
  ADAM_POLICY_15_AUTHENTICATION_LAUNCH = 'ADAM_POLICY_15_AUTHENTICATION_LAUNCH_1012515',
  ADSP_WEBLAB_CAPTCHA = 'ADSP_REGISTRATION_CAPTCHA_1191051',
  SINGLE_GLOBAL_ACCOUNT_LAUNCH = 'SINGLE_GLOBAL_ACCOUNT_LAUNCH_1212308',
}

export enum WeblabTreatment {
  C = 'C',
  T1 = 'T1',
}
